module.exports = __webpack_public_path__ + "static/img/14010202.51e2f1ef.png";